<template>
  <div class="app-payment-information summary-content">
    <slot name="txtBefore"></slot>

    <CreditCardInformation
      v-if="isCreditCard"
      :credit-card-information="payment"
    >
      <template #txtBefore><slot name="txtBeforeCreditCard"></slot></template>
      <template #lblCcHolder><slot name="lblCcHolderCreditCard"></slot></template>
      <template #lblCcNumber><slot name="lblCcNumberCreditCard"></slot></template>
      <template #lblCcType><slot name="lblCcTypeCreditCard"></slot></template>
      <template #lblCcValidty><slot name="lblCcValidtyCreditCard"></slot></template>
      <template #txtAfter><slot name="txtAfterCreditCard"></slot></template>
      <template #txtError><slot name="txtErrorCreditCard"></slot></template>
    </CreditCardInformation>

    <BankAccountInformation
      v-if="isBankAccount"
      :bank-account="payment"
    >
      <template #txtBefore><slot name="txtBeforeBankAccount"></slot></template>
      <template #lblOwner><slot name="lblOwnerBankAccount"></slot></template>
      <template #lblIban><slot name="lblIbanBankAccount"></slot></template>
      <template #txtAfter><slot name="txtAfterBankAccount"></slot></template>
    </BankAccountInformation>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import CreditCardInformation from './CreditCardInformation'
import BankAccountInformation from './BankAccountInformation'
export default {
  name: 'PaymentInformation',
  components: { BankAccountInformation, CreditCardInformation },
  computed: {
    isCreditCard () {
      return this.payment.type === 'creditCard'
    },
    isBankAccount () {
      return this.payment.type === 'bankAccount'
    }
  },
  props: {
    payment: {
      type: Object
    }
  }
}
</script>
